/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./changePeople.vue?vue&type=template&id=6d4961e0&scoped=true&"
import script from "./changePeople.vue?vue&type=script&lang=js&"
export * from "./changePeople.vue?vue&type=script&lang=js&"
import style0 from "./changePeople.vue?vue&type=style&index=0&id=6d4961e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4961e0",
  null
  
)

export default component.exports